import { Link } from "react-router-dom";
import { useLocalePath, useT } from "../i18n";
import { ResponsiveImage } from "./ResponsiveImage";
import { Reveal } from "./Reveal";

export const ShellLayout = ({ crumb, eyebrow, title, children, image, imageAlt, testId }) => {
  const t = useT();
  const lp = useLocalePath();
  return (
    <section data-testid={testId} className="bg-ink text-white">
      <div className="container-x grid min-h-[100svh] gap-12 pb-20 pt-32 lg:grid-cols-12 lg:items-end lg:gap-10 lg:pb-28 lg:pt-40">
        <Reveal className="lg:col-span-6 lg:pb-4">
          <nav aria-label="Breadcrumb" className="text-xs text-white/45" data-testid="breadcrumb">
            <Link to={lp()} className="hover:text-white">{t("nav.home")}</Link>
            <span className="mx-3">/</span>
            <span className="text-white/75">{crumb}</span>
          </nav>
          <p className="eyebrow mt-14 flex items-center gap-4 text-white/55">
            <span className="h-px w-8 bg-current" aria-hidden />
            {eyebrow}
          </p>
          <h1 className="h-section font-display mt-5" data-testid="page-title">{title}</h1>
          {children}
        </Reveal>
        {image && (
          <Reveal delay={0.15} className="lg:col-span-6">
            <div className="relative aspect-[4/3] overflow-hidden bg-graphite lg:aspect-[4/5]">
              <ResponsiveImage image={image} alt={imageAlt} sizes="(min-width: 1024px) 50vw, 100vw" eager className="absolute inset-0 h-full w-full object-cover" />
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
};
